// extracted by mini-css-extract-plugin
module.exports = {"card":"SearchItemBucket_card__AFN07","header":"SearchItemBucket_header__16rjV","listCard":"SearchItemBucket_listCard__2txFP"};